import { render, staticRenderFns } from "./ORegisterEmailEditComp.vue?vue&type=template&id=06b0e0fc&scoped=true&"
import script from "./ORegisterEmailEditComp.vue?vue&type=script&lang=ts&"
export * from "./ORegisterEmailEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./ORegisterEmailEditComp.vue?vue&type=style&index=0&id=06b0e0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0e0fc",
  null
  
)

export default component.exports